import {QueuedCommand} from "../entities/QueuedCommand";
import {IVTag} from "../entities/IVTag";
import {CommandManager} from "../libs/CommandManager";

export class CommandBase {
    selectedItems:any[];
    constructor(public commandManager:CommandManager){
    }
    runCommand(){
        var qqs:QueuedCommand[] = [];
        $.each(this.getItems(), (index: number, vTag: IVTag) => {
            var queuedCommand = new QueuedCommand(null, vTag.vTagID, this.getCommandType(), this.getCommandText(vTag), vTag.readerID);
            qqs.push(queuedCommand);
        });
        this.commandManager.runCommands(qqs);
    }
    getItems(){
        return this.selectedItems;
    }
    getCommandText(asset:IVTag):string{
        return "";
    }
    getCommandType():string{
        return "";
    }
}
